<template>
    <div>
        <!-- Filter Start -->
        <div class="innerBox filter">
            <div class="d-flex flex-row justify-content-between">
                <div><h2 class="page-title">Defect</h2></div>
                <div class="d-flex flex-row justify-content-end">
                    <template v-if="user.type !== 'ADMIN_EKSPEDISI'">
                        <div class="mr-3">
                            <div
                                class="custom-control custom-switch"
                                style="min-width: 150px"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="bongkarGudangSwitch"
                                    v-model="isGudang"
                                />
                                <label
                                    class="custom-control-label"
                                    for="bongkarGudangSwitch"
                                    >{{
                                        isGudang ? "Gudang" : "By Nopol"
                                    }}</label
                                >
                            </div>
                        </div>
                        <div class="mr-3" v-if="!isGudang">
                            <MultiSelect
                                v-model="selected.byDateMonth"
                                :options="
                                    options.byDateMonth.map((x) => x.value)
                                "
                                :custom-label="
                                    (opt) =>
                                        options.byDateMonth.find(
                                            (x) => x.value == opt
                                        ).title
                                "
                                :deselect-label="''"
                                :allow-empty="false"
                                placeholder="Date or Month"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3" v-if="isGudang">
                            <MultiSelect
                                v-model="filter.universalFilter.gudang"
                                :options="
                                    options.warehouse.map((x) => x.loc_code)
                                "
                                :deselect-label="''"
                                placeholder="All Warehouse"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3">
                            <MultiSelect
                                v-model="filter.universalFilter.region"
                                :options="options.region"
                                :deselect-label="''"
                                placeholder="All Regions"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3">
                            <MultiSelect
                                :options="options.ekspedisi.map((x) => x.id)"
                                :custom-label="
                                    (opt) =>
                                        options.ekspedisi.find(
                                            (x) => x.id == opt
                                        ).kode
                                "
                                placeholder="All Ekspedisi"
                                v-model="filter.universalFilter.ekspedisi"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3" v-if="selected.byDateMonth === 1">
                            <div class="input-group">
                                <flat-pickr
                                    :config="rangePickr"
                                    placeholder="Select Date"
                                    v-model="selected.date"
                                ></flat-pickr>
                                <span
                                    class="input-group-text bg-white"
                                    style="
                                        border-top-left-radius: 0;
                                        border-bottom-left-radius: 0;
                                        border: 0;
                                        box-shadow: 0 0 6px #0000000f;
                                        background-color: #ededed !important;
                                    "
                                >
                                    <i
                                        class="fas fa-calendar"
                                        style="color: black"
                                    ></i>
                                </span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="mr-3"></div>
                        <div class="mr-3">
                            <div
                                class="custom-control custom-switch"
                                style="min-width: 150px"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="bongkarGudangSwitch"
                                    v-model="isGudang"
                                />
                                <label
                                    class="custom-control-label"
                                    for="bongkarGudangSwitch"
                                    >{{
                                        isGudang ? "Gudang" : "By Nopol"
                                    }}</label
                                >
                            </div>
                        </div>
                        <div class="mr-3" v-if="!isGudang">
                            <MultiSelect
                                v-model="selected.byDateMonth"
                                :options="
                                    options.byDateMonth.map((x) => x.value)
                                "
                                :custom-label="
                                    (opt) =>
                                        options.byDateMonth.find(
                                            (x) => x.value == opt
                                        ).title
                                "
                                :deselect-label="''"
                                :allow-empty="false"
                                placeholder="Date or Month"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3" v-if="isGudang">
                            <MultiSelect
                                v-model="filter.universalFilter.gudang"
                                :custom-label="
                                    (opt) =>
                                        options.warehouse.find(
                                            (x) => x.loc_code == opt
                                        ).loc_code
                                "
                                :options="
                                    options.warehouse.map((x) => x.loc_code)
                                "
                                :deselect-label="''"
                                placeholder="All Warehouse"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3">
                            <MultiSelect
                                v-model="filter.universalFilter.region"
                                :options="options.region"
                                :deselect-label="''"
                                placeholder="All Regions"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3" v-if="selected.byDateMonth === 1">
                            <div class="input-group">
                                <flat-pickr
                                    :config="rangePickr"
                                    placeholder="Select Date"
                                    v-model="selected.date"
                                ></flat-pickr>
                                <span
                                    class="input-group-text bg-white"
                                    style="
                                        border-top-left-radius: 0;
                                        border-bottom-left-radius: 0;
                                        border: 0;
                                        box-shadow: 0 0 6px #0000000f;
                                        background-color: #ededed !important;
                                    "
                                >
                                    <i
                                        class="fas fa-calendar"
                                        style="color: black"
                                    ></i>
                                </span>
                            </div>
                        </div>
                    </template>
                    <template v-if="!isGudang">
                        <div class="mr-3" v-if="selected.byDateMonth == 2">
                            <MultiSelect
                                v-model="selected.monthYear.month"
                                :options="options.month.map((x) => x.value)"
                                :custom-label="
                                    (opt) =>
                                        options.month.find(
                                            (x) => x.value == opt
                                        ).name
                                "
                                :allow-empty="false"
                                placeholder="Select Month"
                                class="tms-multiselect"
                            />
                        </div>
                        <div class="mr-3" v-if="selected.byDateMonth == 2">
                            <MultiSelect
                                v-model="selected.monthYear.year"
                                :options="options.year"
                                :allow-empty="false"
                                placeholder="Select Year"
                                class="tms-multiselect"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Chart Start -->
        <div class="row" v-if="isGudang">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">Total Delivery</h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Region</h3>
                    </div>
                    <TotalDeliveryChart
                        :data="totalDeliveryData"
                    ></TotalDeliveryChart>
                </div>
            </div>
        </div>

        <div class="row" v-if="isGudang">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">
                            Delivery Unit Distribution
                        </h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Warehouse</h3>
                    </div>
                    <defect-delivery-unit-chart
                        :data="chartData"
                    ></defect-delivery-unit-chart>
                </div>
            </div>
        </div>

        <div class="row" v-if="isGudang">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div class="title-wrapper">
                        <h5 class="section-title">
                            Delivery Unit Distribution
                        </h5>
                        <div class="title-space"></div>
                        <h3 class="section-title-2">by Expedition</h3>
                    </div>
                    <defect-delivery-unit-ekspedisi-chart
                        :data="chartEkspedisiData"
                    ></defect-delivery-unit-ekspedisi-chart>
                </div>
            </div>
        </div>
        <!-- Chart End -->

        <!-- Second Content Start -->
        <div class="row" v-if="isGudang">
            <!-- Most Part Defect Chart Start -->
            <div class="col-lg-6 col-md-6">
                <div class="innerBox mt-4">
                    <h5 class="section-title">
                        Most Part Defect
                        <!-- <i
                          class="fas fa-info-circle"
                          :id="'ScanInfo'"
                      ></i>
                      <b-popover target="ScanInfo" triggers="hover" placement="top">
                          <template #title>Scan vs Active QR</template>
                          {{tooltip.scan_vs_active}}
                      </b-popover> -->
                    </h5>
                    <part-defect-chart :data="partData"> </part-defect-chart>
                </div>
            </div>
            <!-- Most Part Defect Chart Start -->
            <!-- Most Unit Defect Chart Start -->
            <div class="col-lg-6 col-md-6">
                <div class="innerBox mt-4">
                    <h5 class="section-title">
                        Most Unit Defect
                        <!-- <i
                          class="fas fa-info-circle"
                          :id="'ScanInfo'"
                      ></i>
                      <b-popover target="ScanInfo" triggers="hover" placement="top">
                          <template #title>Scan vs Active QR</template>
                          {{tooltip.scan_vs_active}}
                      </b-popover> -->
                    </h5>
                    <unit-defect-chart :data="unitData"> </unit-defect-chart>
                </div>
            </div>
            <!-- Most Unit Defect Chart Start -->
        </div>
        <!-- Second Content End  -->

        <!-- Gudang Start -->
        <div class="row" v-if="isGudang">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <div class="d-flex flex-row justify-content-between">
                        <div><h5 class="section-title">Defect Report</h5></div>
                        <div class="d-flex flex-row justify-content-end">
                            <button
                                class="btn"
                                type="button"
                                style="
                                    background-color: #f36f21;
                                    color: white;
                                    width: 100%;
                                    font-weight: bold;
                                    margin: 0;
                                "
                                @click="exportExcel"
                            >
                                Export Excel
                            </button>
                        </div>
                    </div>
                    <vue-universal-table
                        api_url="/api/reports/defact/detail-part-defect"
                        :filter="filter.universalFilter"
                        :indexing="true"
                        :fields="vue_universal_table.gudang.fields"
                        :update="vue_universal_table.gudang.update"
                        :buttons="vue_universal_table.gudang.buttons"
                        :table_striped="false"
                        :disable_limit_per_page="true"
                        :export_config="
                            vue_universal_table.gudang.export_config
                        "
                        @onSeeDetails="onClick"
                        class="mt-3"
                    ></vue-universal-table>
                </div>
            </div>
        </div>
        <!-- Gudang End -->

        <!-- Bongkar Muat Start -->
        <div class="innerBox mt-4" v-if="!isGudang">
            <div>
                <div>
                    <div class="col-md-3">
                        <input
                            class="nosubmit"
                            type="search"
                            v-model="searchTerm"
                            @input="search"
                            placeholder="Search by nopol"
                        />
                    </div>

                    <div v-if="reportData">
                        <div class="row row-space mt-4 ml-1">
                            <div class="col-md-2">
                                <p style="color: #bcbcbc">Jumlah Muat</p>
                                <p
                                    style="
                                        color: #000000;
                                        font-size: 26px;
                                        font-weight: bold;
                                    "
                                >
                                    {{ reportData.jumlah_angkut }}
                                </p>
                            </div>
                            <div class="col-md-2">
                                <p style="color: #bcbcbc">Defect</p>
                                <div class="row ml-1">
                                    <p
                                        style="
                                            color: #000000;
                                            font-size: 26px;
                                            font-weight: bold;
                                        "
                                    >
                                        {{ reportData.jumlah_rusak }}
                                    </p>
                                    <p
                                        class="ml-2"
                                        style="font-size: 26px; color: #ff5353"
                                    >
                                        {{ reportData.percent }}%
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-1"></div>
                            <div class="col-md-1"></div>
                            <div class="col-md-1"></div>
                            <div class="col-md-3"></div>
                        </div>
                        <label
                            class="ml-3 mt-1"
                            style="
                                color: #4d4d4d;
                                font-weight: bold;
                                font-size: 24px;
                            "
                            >Detail Report</label
                        >
                        <table class="table tms-table mt-2">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Tanggal</th>
                                    <th>Muat</th>
                                    <th>Rusak</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(item, index) in sortedChildren"
                                    :key="index"
                                >
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.tglmuat }}</td>
                                    <td>{{ item.jumlahangkut }}</td>
                                    <td>{{ item.jumlahrusak }}</td>
                                    <td>
                                        <span
                                            style="color: #ff5353"
                                            class="ml-2"
                                            >{{ item.percent_rusak }}%</span
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-else-if="loading">Loading...</div>
                    <div v-else-if="error">Error fetching data</div>
                    <div v-else>No data to display</div>
                </div>
            </div>
        </div>
        <!-- Bongkar Muat End -->
    </div>
</template>

<script>
import qs from "qs";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import axios from "axios";
import moment from "moment";
import debounce from "debounce";
import * as XLSX from "xlsx";
import defectDeliveryUnitChart from "./children/DefectDeliveryUnitChart";
import PartDefectChart from "./children/PartDefectChart";
import UnitDefectChart from "./children/UnitDefectChart";
import TotalDeliveryChart from "./children/TotalDeliveryChart";
import DefectDeliveryUnitEkspedisiChart from "./children/DefectDeliveryUnitEkspedisiChart";

export default {
    metaInfo: {
        title: "Defect",
    },
    data() {
        let startDate = moment().startOf("month").format("YYYY-MM-DD");
        let currentDate = moment().format("YYYY-MM-DD");
        let user = this.$store.getters.currentUser;

        return {
            searchTerm: "",
            data: null,
            loading: false,
            error: null,
            user,
            nopol: "",
            reportData: null,
            searchQuery: "",
            isGudang: true, //true == Gudang, false == bongkar muat
            tableReady: true,
            rangePickr: {
                mode: "range",
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d M Y",
                altInputClass: "form-control input grey-flatpickr",
            },
            selected: {
                byDateMonth: 1, //1 == by date, 2 == by month
                monthYear: {
                    month: parseInt(moment().format("M")),
                    year: moment().format("YYYY"),
                },
                date: `${startDate} to ${currentDate}`,
            },
            options: {
                byDateMonth: [
                    { title: "By Date", value: 1 },
                    { title: "By Month", value: 2 },
                ],
                month: this.$store.getters.getMonth,
                year: this.$store.getters.getYear,
                warehouse: this.$store.getters.getWarehouse,
                region: this.$store.getters.getRegion,
                ekspedisi: this.$store.getters.getEkspedisi,
                // region : [],
            },
            chartData: null,
            unitData: null,
            partData: null,
            totalDeliveryData: null,
            chartEkspedisiData: null,

            filter: {
                universalFilter: {
                    start: startDate,
                    end: currentDate,
                    region: null,
                    gudang: null,
                    ekspedisi: null,
                    flag: "date",
                },

                gudang: {
                    nopol: "",
                    region: null,
                    start: startDate,
                    end: currentDate,
                },

                bongkarMuat: {
                    report: {
                        nopol: "",
                        start: startDate,
                        end: currentDate,
                        region: null,
                    },
                    detail: {
                        nopol: "",
                        start: startDate,
                        end: currentDate,
                        region: null,
                    },
                },
                start: startDate,
                end: currentDate,
                region: null,
                ekspedisi: null,
            },
            tableWidth: "100%",
            tableHeight: "100%",
            rows: [
                {
                    tglmuat: "PT. Transport Maju",
                    jumlahangkut: "L 2349 KJY",
                    jumlahrusak: "Ari",
                },
                {
                    tanggal: "PT. Transport Maju",
                    muat: "L 2349 KJY",
                    rusak: "Ari",
                },
                {
                    tanggal: "PT. Transport Maju",
                    muat: "L 2349 KJY",
                    rusak: "Ari",
                },
                {
                    tanggal: "PT. Transport Maju",
                    muat: "L 2349 KJY",
                    rusak: "Ari",
                },
            ],
            vue_universal_table: {
                gudang: {
                    fields: [
                        {
                            title: "Nopol",
                            variable: "nopolisi",
                            disable_sort: true,
                        },
                        {
                            title: "Driver",
                            variable: "sopir",
                            disable_sort: true,
                        },
                        {
                            title: "Ekspedisi",
                            variable: "ekspedisi_kode",
                            disable_sort: true,
                        },
                        {
                            title: "Gudang Tujuan",
                            variable: "kodegudang",
                            disable_sort: true,
                        },
                        {
                            title: "Tanggal Muat",
                            variable: "tglmuat",
                            disable_sort: true,
                        },
                        {
                            title: "Tanggal Lku",
                            variable: "tgllku",
                            disable_sort: true,
                        },
                        {
                            title: "Muatan",
                            variable: "total_angkut",
                            disable_sort: true,
                        },
                        {
                            title: "Jumlah Rusak",
                            variable: "total_rusak",
                            disable_sort: true,
                        },
                        {
                            title: "Persentasi Defect (%)",
                            variable: "persentase_rusak",
                            disable_sort: true,
                        },
                    ],
                    buttons: [
                        { title: "seeDetails", class: "btn btn-secondary" },
                    ],
                    update: 0,
                },
                bongkarMuat: {
                    report: {
                        fields: [
                            { title: "Nopol", variable: "nopol" },
                            {
                                title: "Tanggal Muat",
                                variable: "tanggal",
                                date_format: "DD/MM/YYYY",
                            },
                            {
                                title: "Deadline Tanggal Bongkar",
                                variable: "tanggal_bongkar",
                                date_format: "DD/MM/YYYY",
                            },
                            { title: "Leadtime", variable: "leadtime" },
                            {
                                title: "Avg. Leadtime Truck",
                                variable: "leadtime_ok",
                            },
                        ],
                        update: 0,
                        buttons: [
                            {
                                title: "comment",
                                class: "btn btn-secondary fas fa-comment",
                            },
                        ],
                        process_data: `
                              for (var i in data) data[i].status = data[i].leadtime_ok == 0 ? 'Late' : 'On Schedule'
                          `,
                    },
                    detail: {
                        fields: [
                            { title: "Nopol", variable: "nopol" },
                            {
                                title: "Leadtime Unit",
                                variable: "percent_leadtime_unit",
                            },
                            {
                                title: "Avg. Leadtime Unit",
                                variable: "avg_leadtime_unit",
                            },
                            {
                                title: "Leadtime Truck",
                                variable: "percent_leadtime_truck",
                            },
                            {
                                title: "Avg. Leadtime Truck",
                                variable: "avg_leadtime_truck",
                            },
                        ],
                        update: 0,
                        buttons: [
                            {
                                title: "seeDetails",
                                variable: "nopol",
                                class: "btn btn-secondary",
                            },
                        ],
                        process_data: `
                              for (var i in data) {
                                  data[i].percent_leadtime_unit = data[i].percent_leadtime_unit + "%"
                                  data[i].avg_leadtime_unit = data[i].avg_leadtime_unit + " Days"
                                  data[i].percent_leadtime_truck = data[i].percent_leadtime_truck + "%"
                                  data[i].avg_leadtime_truck = data[i].avg_leadtime_truck + " Days"
                              }
                          `,
                    },
                },
            },
        };
    },
    components: {
        // planAlokasiChart,
        defectDeliveryUnitChart,
        UnitDefectChart,
        PartDefectChart,
        TotalDeliveryChart,
        DefectDeliveryUnitEkspedisiChart,
    },
    computed: {
        paginatedData() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.apiData
                ? this.apiData.detail.slice(startIndex, endIndex)
                : [];
        },
        filteredChildren() {
            if (!this.searchQuery) {
                return this.reportData.children;
            }
            return this.reportData.children.filter((child) =>
                child.tglmuat
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase())
            );
        },
        // Sort the children array by date in ascending order
        sortedChildren() {
            if (this.reportData && this.reportData.children) {
                return this.reportData.children.slice().sort((a, b) => {
                    // Parse dates and compare them
                    const dateA = new Date(a.tglmuat);
                    const dateB = new Date(b.tglmuat);
                    return dateA - dateB;
                });
            }
            return [];
        },
    },
    watch: {
        isGudang() {
            this.tableReady = false;
            this.resetDefaultDate();
            this.selected.byDateMonth = 1;

            this.delayedFetchData();

            setTimeout(() => {
                this.tableReady = true;
            }, 1);
        },
        "selected.byDateMonth"() {
            this.selected.byDateMonth === 1
                ? (this.filter.universalFilter.flag = "date")
                : (this.filter.universalFilter.flag = "month");
            this.delayedFetchData();
        },
        "selected.monthYear": {
            deep: true,
            handler() {
                var selectedDate = moment().set({
                    year: this.selected.monthYear.year,
                    month: this.selected.monthYear.month - 1,
                });
                this.selected.date = `${selectedDate
                    .startOf("month")
                    .format("YYYY-MM-DD")} to ${selectedDate
                    .endOf("month")
                    .format("YYYY-MM-DD")}`;
            },
        },
        "selected.date"(newValue) {
            const [start, end] = newValue.split(" to ");
            this.filter.start = moment(start).format("YYYY-MM-DD");
            this.filter.end = moment(end || start).format("YYYY-MM-DD");
            this.filter.universalFilter.start =
                moment(start).format("YYYY-MM-DD");
            this.filter.universalFilter.end = moment(end).format("YYYY-MM-DD");
        },
        /* Filter watchers start */
        "filter.gudang": {
            deep: true,
            handler() {
                if (!this.isGudang) return;
                this.updateGudang();
            },
        },
        "filter.bongkarMuat.report": {
            deep: true,
            handler() {
                if (this.isGudang) return;
                this.updateBongkarMuatReport();
            },
        },
        "filter.bongkarMuat.detail": {
            deep: true,
            handler() {
                if (this.isGudang) return;
                this.updateBongkarMuatDetail();
            },
        },
        /* Filter watchers end */
        filter: {
            deep: true,
            immediate: true,
            handler: "delayedFetchData",
        },

        "filter.universalFilter": {
            deep: true,
            handler() {
                //Loop everything in the filter above
                for (var i in this.filter.universalFilter) {
                    //In Transit does not have date filter
                    if ((i == "start" || i == "end") && this.isGudang) continue;

                    this.filter.gudang[i] = this.filter.universalFilter[i];
                    this.filter.bongkarMuat.report[i] =
                        this.filter.universalFilter[i];
                    this.filter.bongkarMuat.detail[i] =
                        this.filter.universalFilter[i];
                }

                if (
                    this.filter.universalFilter.region === "All" ||
                    this.filter.universalFilter.ekspedisi === 999 ||
                    this.filter.universalFilter.gudang === "All"
                ) {
                    this.filter.universalFilter = {
                        ...this.filter.universalFilter,
                        region: null,
                        gudang: null,
                        ekspedisi: null,
                    };
                }

                this.updateGudang();
            },
        },
    },
    methods: {
        exportExcel() {
            this.$http
                .get(
                    `/api/reports/defact/export-detail-part-defect?${qs.stringify(
                        this.filter.universalFilter,
                        { skipNulls: true, arrayFormat: "comma" }
                    )}`
                )
                .then((resp) => {
                    let wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(resp.data.data, {
                        raw: true,
                    });
                    XLSX.utils.book_append_sheet(wb, ws, "Data");

                    let exportFileName = `detail-part-defect-${moment()
                        .utc()
                        .utcOffset("+07:00")
                        .format("YYYYMMDDHHmmss")}.xlsx`;
                    XLSX.writeFile(wb, exportFileName);
                });
        },
        search() {
            if (!this.searchTerm) {
                this.data = null;
                return;
            }

            this.loading = true;

            const startDate = moment(
                this.selected.date.split(" to ")[0],
                "YYYY-MM-DD"
            ).format("YYYY-MM-DD");
            const endDate = moment(
                this.selected.date.split(" to ")[1],
                "YYYY-MM-DD"
            ).format("YYYY-MM-DD");

            const queryParams = {
                nopol: this.searchTerm,
                start: startDate,
                end: endDate,
            };

            // Use qs.stringify to convert the queryParams object to a query string
            const queryString = qs.stringify(queryParams);

            // Make the API request using Axios with the query string
            axios
                .get(`/api/reports/defact/by-nopol?${queryString}`)
                .then((response) => {
                    this.loading = false;
                    this.reportData = response.data.data[0];
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.message;
                });
        },
        //Will chain reaction to watch
        resetDefaultDate() {
            this.selected.date = `${moment()
                .startOf("month")
                .format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`;
            this.monthYear = {
                month: moment().format("M"),
                year: moment().format("YYYY"),
            };
        },

        updateGudang: debounce(function () {
            this.vue_universal_table.gudang.update++;
        }, 1000),
        updateBongkarMuatReport: debounce(function () {
            this.vue_universal_table.bongkarMuat.report.update++;
        }, 1000),
        updateBongkarMuatDetail: debounce(function () {
            this.vue_universal_table.bongkarMuat.detail.update++;
        }, 1000),

        delayedFetchData: debounce(function () {
            this.fetchData();
        }, 1000),
        fetchData() {
            if (this.isGudang) {
                // Delivery Unit Distribution Chart
                // this.chartData = []
                this.$http
                    .get(
                        `/api/reports/defact/by-region?${qs.stringify(
                            this.filter.universalFilter,
                            { skipNulls: true, arrayFormat: "comma" }
                        )}`
                    )
                    .then((resp) => {
                        this.totalDeliveryData = resp.data.data;
                    });

                this.$http
                    .get(
                        `/api/reports/defact/by-gudang?${qs.stringify(
                            this.filter.universalFilter,
                            { skipNulls: true, arrayFormat: "comma" }
                        )}`
                    )
                    .then((resp) => {
                        this.chartData = resp.data.data;
                    })
                    .catch((err) => console.log(err));

                this.$http
                    .get(
                        `/api/reports/defact/by-ekspedisi?${qs.stringify(
                            this.filter.universalFilter,
                            { skipNulls: true, arrayFormat: "comma" }
                        )}`
                    )
                    .then((resp) => {
                        this.chartEkspedisiData = resp.data.data;
                    })
                    .catch((err) => console.log(err));

                // Most Part Defect Chart
                // this.unitData = []
                delete this.filter.universalFilter.flag;
                this.$http
                    .get(
                        `/api/reports/defact/by-periode?flag=unit&${qs.stringify(
                            this.filter.universalFilter,
                            { skipNulls: true, arrayFormat: "comma" }
                        )}`
                    )
                    .then((resp) => {
                        this.unitData = resp.data.data;
                    })
                    .catch((err) => console.log(err));

                // Most Part Defect Chart
                // this.partData = []
                this.$http
                    .get(
                        `/api/reports/defact/by-periode?flag=part&${qs.stringify(
                            this.filter.universalFilter,
                            { skipNulls: true, arrayFormat: "comma" }
                        )}`
                    )
                    .then((resp) => {
                        this.partData = resp.data.data;
                    })
                    .catch((err) => console.log(err));
            } else {
                // Nopol Detail
                // this.reportData = []
                this.$http
                    .get(
                        `/api/reports/defact/by-nopol?${qs.stringify(
                            this.filter.universalFilter,
                            { skipNulls: true, arrayFormat: "comma" }
                        )}`
                    )
                    .then((resp) => {
                        this.reportData = resp.data.data[0];
                    })
                    .catch((err) => console.log(err));
            }
        },

        seeDetail(nopol) {
            this.$router.push({
                path: `/dashboard/leadtime/detail/${nopol.replace(/"/g, "")}`,
                query: {
                    start: this.filter.bongkarMuat.detail.start,
                    end: this.filter.bongkarMuat.detail.end,
                },
            });
        },

        onClick(defect) {
            this.$store.state.defectData = defect;
            this.$router.push({ path: "/dashboard/defect/detail" });
        },
    },
};
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
}

.align-middle {
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 27px;
    font-weight: bold;
    margin: 0;
}

.title-wrapper {
    display: flex; /* Use flexbox */
    align-items: baseline; /* Align items along the baseline */
}

.title-space {
    margin-right: 5px; /* Adjust the space by changing the margin */
}

.section-title {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    color: #4d4d4d;
}

.section-title-2 {
    font-size: 15px;
    font-weight: bold;
    margin: 0;
    color: #4d4d4d;
}

.custom-control-label {
    padding: 4px 24px;
}

.custom-control-label::before {
    background-color: #f5b76e;
    width: 48px;
    height: 24px;
    border: 0;
    border-radius: 16px;
    cursor: pointer;
    top: 50%;
    margin-top: -12px;
}

.custom-control-label::after {
    width: 24px;
    height: 24px;
    border-radius: 1000px;
    background-color: #f8f8f8;
    top: 50%;
    margin-top: -12px;
    left: -2.25rem;
    cursor: pointer;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(24px);
}

.tms-table thead tr th,
.table-title {
    font-weight: normal;
    color: #bcbcbc;
}

.tms-table thead tr th,
.tms-table tbody tr td {
    vertical-align: middle;
    font-size: 14px;
}

.tms-table .no-border td {
    border: 0;
    padding: 5px;
}

.prefix-icon {
    position: absolute;
    right: 15px;
    top: 20px;
    transform: translateY(-50%);
}

.prefix-input .elegant-flatpickr {
    padding-right: 35px;
}

input.nosubmit {
    border: 1px solid #555;
    width: 100%;
    padding: 9px 4px 9px 40px;
    background: transparent
        url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
        no-repeat 13px center;
}
</style>
